var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-3",
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v("\n        Offline Requests\n      ")])], 1)], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-list', [_vm.offlineRequests.length ? _vm._l(_vm.offlineRequests, function (request) {
    return _c('v-list-tile', {
      key: request.id,
      attrs: {
        "ripple": ""
      }
    }, [_c('v-list-tile-action', [_vm._v("\n            " + _vm._s(request.id) + "\n          ")]), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(request.type))]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(request.objectId))])], 1)], 1);
  }) : [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("No offline requests found")])]], 2), _c('div', {
    staticClass: "text-center"
  }, [_vm.offlineRequests.length ? _c('v-btn', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.sendOfflineRequest.apply(null, arguments);
      }
    }
  }, [_vm._v("\n        Send the Request again\n      ")]) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }